import { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

export class FeatureToggle extends Component {
  render() {
    const toggleState = window.isToggleOn(this.props.featureName);
    const showContent = !!toggleState === !this.props.showWhenFeatureToggleOff;
    return showContent ? this.props.children : null;
  }
}

const mapStateToProps = (state) => {
  return {
  };
};

FeatureToggle.propTypes = {
  featureName: PropTypes.string.isRequired,
  showWhenFeatureToggleOff: PropTypes.bool,
  children: PropTypes.node
};

FeatureToggle.defaultProps = {
  showWhenFeatureToggleOff: false
};

export default connect(mapStateToProps)(FeatureToggle);
